import type { LiabilityFormLayout } from "../types";

export const liabilityPaymentScheduleLayout = (): LiabilityFormLayout => {
  return {
    key: 'liabilityPaymentScheduleLayout',
    attributes: {
      class: 'grid grid-cols-1 md:grid-cols-2 gap-4'
    },
    needs: ['hasPaymentSchedule'],
    children: (state) => {

      console.log({ hasPaymentSchedule: state.hasPaymentSchedule })
      if (state.hasPaymentSchedule) {
        return [
          { render: 'hasPaymentSchedule', key: 'hasPaymentSchedule' },
          { render: 'paymentSchedule', key: 'paymentSchedule' }
        ]
      }

      return [
        { render: 'hasPaymentSchedule', key: 'hasPaymentSchedule' },
        {
          key: 'NOT_hasPaymentSchedule',
          component: () => {
            return () => {
              return <div class="px-3 w-full h-[46px] bg-gray-100 border border-gray-300 flex-col justify-center items-center inline-flex">
                <div class="text-center text-gray-500 text-[10px] font-normal font-['Inter'] leading-[15px]">
					No amortization schedule set
                </div>
              </div>
            }
          }
        }
      ]
    }
   // children: (state) => [
   //   { render: 'hasPaymentSchedule' },
   //   ...(state.hasPaymentSchedule ? [
   //     { render: 'paymentSchedule' }
   //   ] : [
   //
   //   ])
   // ]
  }
}
